import { ChangePasswordInput, CookieConsentCustomerDto, LoginResponse, ResetPasswordInput } from '@app/api';

export class Login {
  static readonly type = '[Account] Login';
}

export class Logout {
  static readonly type = '[Account] Logout';
}

export class StartLoginSession {
  static readonly type = '[Account] StartLoginSession';
}

export class LoginFailure {
  static readonly type = '[Account] LoginFailure';

  constructor(public loginResponse: LoginResponse) {}
}

export class LoginSuccessEvent {
  static readonly type = '[Event][Account] LoginSuccess';
}

export class StartNewForgotPasswordSession {
  static readonly type = '[Account] StartNewForgotPasswordSession';
}

export class ForgotPasswordRequest {
  static readonly type = '[Account] ForgotPasswordRequest';

  constructor(public email: string) {}
}

export class ClearErrors {
  static readonly type = '[Account] ClearErrors';
}

export class StartNewChangePasswordSession {
  static readonly type = '[Account] StartNewChangePasswordSession';
}

export class ChangePassword {
  static readonly type = '[Account] ChangePassword';

  constructor(public payload: ChangePasswordInput) {}
}

export class StartNewResetPasswordSession {
  static readonly type = '[Account] StartNewResetPasswordSession';
}

export class ResetPassword {
  static readonly type = '[Account] ResetPassword';

  constructor(public payload: ResetPasswordInput) {}
}

export class GetCookieConsent {
  static readonly type = '[Account] GetCookieConsent';
}

export class UpdateCookieConsent {
  static type = '[Account] UpdateCookieConsent';

  constructor(public payload: CookieConsentCustomerDto) {}
}

export class UpdateLocalCookieConsent {
  static readonly type = '[Account] UpdateLocalCookieConsent';

  constructor(public payload: { ccAnalytics: boolean; ccMarketing: boolean }) {}
}

export class ShowCookieConsentModal {
  static readonly type = '[Account] ShowCookieConsentModal';
}

export class HideCookieConsentModal {
  static readonly type = '[Account] HideCookieConsentModal';
}

export class GetEmailConsent {
  static readonly type = '[Account] GetEmailConsent';
}

export class UpdateEmailConsent {
  static readonly type = '[Account] UpdateEmailConsent';

  constructor(public payload: { accept: boolean }) {}
}

export class SetEmail {
  static readonly type = '[Account] SetEmail';

  constructor(public email: string) {}
}
